import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://social-auto-r8we.onrender.com/api/instagram';

export const addAccount = createAsyncThunk(
    'instagram/addAccount',
    async ({ username, password }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(`${API_URL}/accounts`, { username, password }, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to add account');
        }
    }
);

export const getAccounts = createAsyncThunk(
    'instagram/getAccounts',
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.get(`${API_URL}/accounts`, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to get accounts');
        }
    }
);

export const createPost = createAsyncThunk(
    'instagram/createPost',
    async ({ accountId, image, caption }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const formData = new FormData();
            formData.append('accountId', accountId);
            formData.append('image', image);
            if (caption) formData.append('caption', caption);
            const config = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } };
            const { data } = await axios.post(`${API_URL}/create-post`, formData, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to create post');
        }
    }
);

export const sendDM = createAsyncThunk(
    'instagram/sendDM',
    async ({ accountId, recipientUsername, message }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(`${API_URL}/send-dm`, { accountId, recipientUsername, message }, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to send DM');
        }
    }
);

const instagramSlice = createSlice({
    name: 'instagram',
    initialState: { accounts: [], selectedAccount: null, loading: false, error: null },
    reducers: { selectAccount: (state, action) => { state.selectedAccount = action.payload; } },
    extraReducers: (builder) => {
        builder
            .addCase(addAccount.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(addAccount.fulfilled, (state, action) => { state.loading = false; state.accounts.push(action.payload.account); state.selectedAccount = action.payload.account._id; })
            .addCase(addAccount.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
            .addCase(getAccounts.fulfilled, (state, action) => { state.accounts = action.payload.data || []; if (state.accounts.length > 0 && !state.selectedAccount) state.selectedAccount = state.accounts[0]._id; })
            .addCase(createPost.pending, (state) => { state.loading = true; })
            .addCase(createPost.fulfilled, (state) => { state.loading = false; })
            .addCase(createPost.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
            .addCase(sendDM.pending, (state) => { state.loading = true; })
            .addCase(sendDM.fulfilled, (state) => { state.loading = false; })
            .addCase(sendDM.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    },
});

export const { selectAccount } = instagramSlice.actions;
export default instagramSlice.reducer;
